









import { CreateElement, VNode } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<TinySpinner>({
  name: 'TinySpinner',
})
export default class TinySpinner extends Vue {
  @Prop({ type: String, required: false, default: 's' })
  size!: string;

  get styles() {
    let basePX: number;
    switch (this.size.toLowerCase()) {
      case 's':
        basePX = 16;
        break;
      case 'm':
        basePX = 32;
        break;
      case 'l':
        basePX = 64;
        break;
      default:
        throw Error(`Invalid Specification: size: ${this.size}`);
    }

    const wrapperSize = `${basePX}px`;
    const ringSize = `${basePX / 1.25}px`;
    const ringMargin = `${basePX / 10.6}px`;
    return {
      wrapper: { width: wrapperSize, height: wrapperSize },
      ring: { width: ringSize, height: ringSize, margin: ringMargin, 'border-width': ringMargin },
    };
  }
}
